import * as actions from "./actions";
import update from "immutability-helper";

import _ from "underscore";
import {
  USER_APPLICATION_LIST_GET_REQUEST,
  USER_APPLICATION_LIST_GET_SUCCESS,
  USER_APPLICATION_LIST_GET_ERROR,
  CREATE_KREDITZ_REVIEW_POST_REQUEST,
  CREATE_KREDITZ_REVIEW_POST_ERROR,
  CREATE_KREDITZ_REVIEW_POST_SUCCESS,
} from "../actions";
import moment from "moment";

let initialState = {
  applications: {
    fetching: false,
    fetched: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: [],
  },

  approve: {
    approved: false,
    error: null,
  },

  reject: {
    rejected: false,
    error: null,
  },
};

const applications = (state = initialState, action) => {
  switch (action.type) {
    // GET APPLICATIONS
    case USER_APPLICATION_LIST_GET_REQUEST:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          fetching: true,
          fetchError: null,
          data: [],
        }),
      });

    case USER_APPLICATION_LIST_GET_SUCCESS: {
      let data = Array.isArray(action.response)
        ? action.response
        : [action.response];
      let datenow = moment(new Date()).subtract(30, "days");
      let allData = data;

      data = _.filter(data, (value) => {
        return moment(value.DateSubmitted).isAfter(datenow);
      });

      data = data.sort((a, b) => {
        return a.DateSubmitted - b.DateSubmitted;
      });

      //ToDo: remove swapData when termination from backend is ready
      // for now it will swap the filtered data with all data
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          fetching: false,
          fetched: true,
          data,
          swapData: allData,
        }),
      });
    }

    case actions.USER_SWAP_APPLICATION_DATA: {
      let data = state.applications.data;
      let swapData = state.applications.swapData;

      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          data: swapData,
          swapData: data,
        }),
      });
    }

    case USER_APPLICATION_LIST_GET_ERROR:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          fetching: false,
          error: action.error,
        }),
      });

    case actions.USER_APPLICATION_LIST_CHANGE_PAGE:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          table: Object.assign({}, state.applications.table, {
            pagination: Object.assign({}, state.applications.table.pagination, {
              page: action.page,
            }),
          }),
        }),
      });

    case actions.USER_APPLICATION_LIST_CHANGE_FILTER:
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          table: Object.assign({}, state.applications.table, {
            currentFilter: Object.assign(
              {},
              state.applications.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    // APPROVE APPLICATION

    case actions.USER_APPLICATION_APPROVE_SUCCESS: {
      let id = action.dataSent.ApplicationId;
      let toChangeIndex = _.findIndex(state.applications.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.applications.data[toChangeIndex],
        {},
      );
      //Approved stage
      toChange.Stage = "ManuallyApproved";

      return Object.assign({}, state, {
        approve: Object.assign({}, state.approve, {
          approved: true,
          error: null,
        }),
        applications: Object.assign({}, state.applications, {
          data: [
            ...state.applications.data.slice(0, toChangeIndex),
            toChange,
            ...state.applications.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.USER_APPLICATION_APPROVE_ERROR:
      return Object.assign({}, state, {
        approve: Object.assign({}, state.approve, {
          approved: false,
          error: action.error,
        }),
      });
    // REJECT APPLICATION

    case actions.USER_APPLICATION_REJECT_SUCCESS: {
      let id = action.dataSent.ApplicationId;
      let toChangeIndex = _.findIndex(state.applications.data, (item) => {
        return item.Id == id;
      });

      let toChange = Object.assign(
        {},
        state.applications.data[toChangeIndex],
        {},
      );
      //Rejected stage
      toChange.Stage = "ManuallyRejected";

      return Object.assign({}, state, {
        reject: Object.assign({}, state.reject, {
          rejected: true,
          error: null,
        }),
        applications: Object.assign({}, state.applications, {
          data: [
            ...state.applications.data.slice(0, toChangeIndex),
            toChange,
            ...state.applications.data.slice(toChangeIndex + 1),
          ],
        }),
      });
    }

    case actions.USER_APPLICATION_REJECT_ERROR:
      return Object.assign({}, state, {
        reject: Object.assign({}, state.reject, {
          rejected: false,
          error: action.error,
        }),
      });

    /* additional data for application */
    case actions.USER_EXPANDED_DATA_BISNODE_REQUEST: {
      let current_item_index = get_item_index(
        state.applications.data,
        action.correlation.Id,
      );
      let applications = state.applications.data;
      applications[current_item_index].newDataLoading = true;
      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          data: applications,
        }),
      });
    }

    case actions.USER_EXPANDED_DATA_BISNODE_SUCCESS: {
      let current_item_index = get_item_index(
        state.applications.data,
        action.correlation.Id,
      );
      let applications = state.applications.data;
      applications[current_item_index].bisnodeData = action.response;

      return Object.assign({}, state, {
        applications: Object.assign({}, state.applications, {
          data: applications,
        }),
      });
    }

    case CREATE_KREDITZ_REVIEW_POST_REQUEST: {
      const apps = state.applications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex == -1) return state;

      return update(state, {
        applications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: true },
            },
          },
        },
      });
    }

    case CREATE_KREDITZ_REVIEW_POST_ERROR: {
      const apps = state.applications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex == -1) return state;

      return update(state, {
        applications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: false },
              kreditzError: { $set: action.error },
            },
          },
        },
      });
    }

    case CREATE_KREDITZ_REVIEW_POST_SUCCESS: {
      const apps = state.applications.data;
      const applicationToUpdateIndex = _.findIndex(
        apps,
        (app) => app.Id === action.dataSent.ApplicationId,
      );
      if (applicationToUpdateIndex == -1) return state;

      return update(state, {
        applications: {
          data: {
            [applicationToUpdateIndex]: {
              createKreditzReviewPending: { $set: false },
            },
          },
        },
      });
    }

    default:
      return state;
  }
};

function get_item_index(array, id) {
  for (var index = 0; index < array.length; index++) {
    var element = array[index];
    if (element.Id == id) {
      return index;
    }
  }
}

export default applications;
